module.exports = __webpack_public_path__ + "static/img/170810-allen-chan-and-dennis-lo.b838a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170810-allen-chan-and-dennis-lo.jpg
// module id = xLBw
// module chunks = 0